<template>
  <main id="main">
    <Loading :isProcessing="isProcessing"></Loading>
    <div v-if="!isProcessing">
    <DiagCorpHeader
      :corpName="corpName"
      :corporateFeatureInfoLabels="corporateFeatureInfoLabels"
      :corporateSelectable="isAdmin"
      :manageCorpName="manageCorpName"
      :isAdmin="isAdmin"
      :isDiagAvailablePlan="isDiagAvailablePlan"
      @select-corporate="emitSelectCorpList"
    ></DiagCorpHeader>
    <DiagHeaderNavigation
      :answeredDiagResultItemsCountTotal="score"
      :diagItemsCountTotal="totalScore"
    ></DiagHeaderNavigation>

    <div class="l-contents">
      <DiagNavigation
        :isAdmin="isAdmin"
        :isIpo="isIpo"
      ></DiagNavigation>
      <div class="l-contentsBox">
        <h1 class="l-pageTitle">
          <span class="number-text">
            <span class="number is-blue">{{ sortOrder }}</span>
            <span class="text" style="white-space: pre-line;">{{ diagResultItem.diagItem.task }}</span>
          </span>
        </h1>
        <div class="l-auditTask__header">
          <div class="l-auditQustion">
            <p class="l-text u-mb20" style="white-space: pre-line;"><strong>質問：{{ diagResultItem.diagItem.checkItem }}</strong></p>
            <div class="l-auditQustion">
              <div class="l-auditQustion__label">
                <dl class="l-auditQustion__status" style="margin-right: 0;">
                  <dt v-if="!isIpo">リスク</dt>
                  <dd v-if="!isIpo">
                    <!--<span class="label" :class="diagResultItem.diagItem.riskLevel.displayLabelClass" v-tooltip.top="diagResultItem.diagItem.riskLevel.description" data-tooltip="">{{ diagResultItem.diagItem.riskLevel.name }}</span>-->
                    <span class="label" :class="diagResultItem.diagItem.riskLevel.displayLabelClass" data-tooltip="" @mouseover="toggle(diagResultItem.diagResultItemId)" @mouseleave="toggleb(diagResultItem.diagResultItemId)">
                      <span class="tooltip is-right" :id="diagResultItem.diagResultItemId" >{{diagResultItem.diagItem.riskLevel.description}}</span>
                      {{ diagResultItem.diagItem.riskLevel.name }}
                    </span>
                  </dd>

                  <dt v-if="isIpo">IPO重要度</dt>
                  <dd v-if="isIpo">
                    <span class="label-level" :class="diagResultItem.diagItem.ipoImportance.displayLabelClass" data-tooltip="" @mouseover="toggle(diagResultItem.diagResultItemId)" @mouseleave="toggleb(diagResultItem.diagResultItemId)">
                      <span class="tooltip is-right" :id="diagResultItem.diagResultItemId" >{{diagResultItem.diagItem.ipoImportance.description}}</span>
                      {{ diagResultItem.diagItem.ipoImportance.name }}
                    </span>
                  </dd>

                  <dt>カテゴリ</dt>
                  <dd>{{ diagResultItem.diagItem.diagSection.sectionNm }}</dd>
                </dl>
              </div>
            </div>
            <table class="table-base">
              <tr>
                <th>回答</th><td>{{ diagResultItem.answerText }}</td>
                <th>対応期限</th>
                <td>
                  <span v-if="diagResultItem.dueDate">{{ $dayjs(diagResultItem.dueDate).format("YYYY年MM月DD日") }}</span>
                  <span v-else>未設定</span>
                </td>
                <th>優先度</th>
                <td>
                  <span v-if="diagResultItem.isHighPriority">高</span>
                  <span v-else>-</span>
                </td>
              </tr>
            </table>
          </div>
        </div>

        <div class="l-contentsSection">
          <div class="l-contentsGrid2">
            <div class="l-contentsGrid2__item">
              <div class="l-grayBox">
                <div>
                  <h4 class="l-headding is-small has-icon"><img src="@/assets/img/common/icon-point.svg" alt="" class="icon">ヒント</h4>
                  <p class="l-text" style="white-space: pre-line;">{{ diagResultItem.diagItem.remediation }}</p>
                </div>
              </div>
            </div>
            <div class="l-contentsGrid2__item">
              <div class="l-grayBox">
                <div>
                  <h4 class="l-headding is-small has-icon"><img src="@/assets/img/common/icon-check.svg" alt="" class="icon">
                    <span>改善の方向性</span><a v-if="isAdminUser && (solutionList.length > 0)" href="#solution" class="text-link rightItem js-link-scroll">おすすめソリューションはこちら</a>
                  </h4>
                  <p v-if="!isIpo" class="l-text" style="white-space: pre-line;" v-html="repalceLink(diagResultItem.laborConsultantComment)"></p>
                  <p v-if="isIpo" class="l-text" style="white-space: pre-line;" v-html="repalceLink(diagResultItem.laborConsultantCommentForIpo)"></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="l-contentsSection">

          <div class="l-contentsGrid2">
            <div class="l-contentsGrid2__item">
              <div>
                <div class="btn-basic is-middle is-inlne" @click="showEgovProvision(true)" :class="{'gray-out': !diagResultItem.diagItem.provisionsDetail}">
                  <a :class="{'gray-out': !diagResultItem.diagItem.provisionsDetail}">対応条文 e-Gov</a>
                </div>
                <div class="btn-basic is-middle is-inlne" @click="downloadGuideFile()" :class="{'gray-out': !diagResultItem.diagItem.guideCd}">
                  <a :class="{'gray-out': !diagResultItem.diagItem.guideCd}">ガイド</a>
                </div>
              </div>
            </div>

            <div class="l-contentsGrid2__item">
              <div class="l-contentsMemo">
                <div class="l-formGroup">
                  <div class="l-contentsMemo__title">
                    <label class="l-formGroup__label">現状/課題</label>
                    <button v-if="!isRemarksEditable" class="link-arrow" @click="changeRemarksEditable(true)">編集する</button>
                    <button v-if="isRemarksEditable" class="link-arrow" @click="changeRemarksEditable(false)">編集を終わる</button>
                  </div>
                  <div v-if="!isRemarksEditable" class="l-contentsMemo__body">
                    <div class="l-grayBox">
                      <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(diagResultItem.remarks)"></p>
                    </div>
                  </div>
                  <div v-if="isRemarksEditable" class="l-formGroup">
                    <TextArea class="l-formGroup__textArea auto-height" v-model="diagResultItem.remarks" @input="() => isAnswerChanged = true"></TextArea>
                  </div>
                  <ValidationErrorMessage v-show="$v.diagResultItem.remarks.$error && !$v.diagResultItem.remarks.maxLength" validation="maxLength" valueLength="500" />
                </div>
              </div>
            </div> <!-- l-contentsGrid2__item end -->
          </div>

          <div class="l-contentsGrid2">

            <div class="l-contentsGrid2__item">
              <div></div>
            </div>

            <div class="l-contentsGrid2__item">
              <div class="l-contentsMemo">
                <div class="l-formGroup">
                  <div class="l-contentsMemo__title">
                    <label class="l-formGroup__label">参考資料URL</label>
                    <button v-if="!urlForms[0].viewFlag" class="link-arrow" @click="changeForm(true)">編集する</button>
                    <button v-if="urlForms[0].viewFlag" class="link-arrow" @click="changeForm(false)">編集を終わる</button>
                  </div>
                  <div v-for="(form, index) in urlForms" :key="index">
                    <div v-if="!urlForms[index].viewFlag" class="l-contentsMemo__body">
                      <div class="l-grayBox">
                        <p class="l-text" style="white-space: pre-line;" v-html="repalceLink(urlForms[index].content)"></p>
                      </div>
                    </div>
                    <div v-if="urlForms[index].viewFlag" class="l-formGroup">
                      <TextArea class="l-formGroup__textArea auto-height" v-model="urlForms[index].content" @input="() => isAnswerChanged = true"></TextArea>
                    </div>
                  </div>
                </div>
              </div>
            </div> <!-- l-contentsGrid2__item end -->

          </div>
        </div>
        <div class="l-contentsBox__bottom">
          <div class="btn-group">
            <div class="btn-basic is-inlne is-primary">
              <label>
                <span>
                  <CheckBox v-model="diagResultItem.taskFixedFlg" :value="true"
                    :checked="diagResultItem.taskFixedFlg"
                    labelText="対応済"
                    @input="() => isAnswerChanged = true" />
                </span>
              </label>
            </div>
            <div class="btn-basic is-inlne is-primary js-save" @click="save()"><a>保存</a></div>
          </div>
        </div>
      </div>
    </div>
    <div class="l-contents">
      <ul class="l-pageNav">
        <li @click="goTaskDetail(previous.diagResultItemId)">
          <template v-if="previous.diagResultItemId">
            <a>{{ previousCheckItemLabel }}</a>
          </template>
        </li>
        <li @click="goTaskList()"><a>課題リスト一覧</a></li>
        <li @click="goTaskDetail(next.diagResultItemId)">
          <template v-if="next.diagResultItemId">
            <a>{{ nextCheckItemLabel }}</a>
          </template>
        </li>
      </ul>
    </div>
    <div class="l-bgGray" v-if="isAdmin && (solutionList.length > 0)">
      <div class="l-contents">
        <h2 class="l-pageTitle" id="solution"><img src="@/assets/img/common/icon-nav5_blue.svg" alt="">おすすめソリューション</h2>
          <ul class="l-solutionList">
            <li class="l-solutionList__item" v-for="solution in solutionList" :key="solution.solutionId" @click="goSolutionDetail(solution.solutionId)">
              <a>
                <div class="l-solutionList__img" :style="'background-image: url(' + solution.thumbNailImageFile + ');'"></div>
                <p class="l-solutionList__title">{{ solution.name }}</p>
                <p class="l-solutionList__text" style="overflow-wrap: normal; word-break: break-all; white-space: pre-line;">{{ solution.descriptionForList }}</p>
              </a>
            </li>
          </ul>
      </div>
    </div>
    <transition name="egovprovisionmodal-fade">
      <EgovProvisionsModal
        v-if="isShowEgovProvision"
        :itemId="diagResultItem.itemId"
        @hide-egov-provision-modal="showEgovProvision(false)"
      ></EgovProvisionsModal>
    </transition>
  </div>
  </main>
</template>

<script src="https://code.jquery.com/jquery-3.5.1.min.js "></script>

<script>
import Loading from '@/components/parts/common/Loading.vue';
import DiagCorpHeader from '@/components/parts/diag/DiagCorpHeader.vue';
import DiagHeaderNavigation from '@/components/parts/diag/DiagHeaderNavigation.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import CheckBox from '@/components/parts/form/CheckBox.vue';
import EgovProvisionsModal from '@/components/parts/master/EgovProvisionsModal.vue';
import { saveAs } from "file-saver";
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import { maxLength } from 'vuelidate/lib/validators';
import DiagNavigation from '@/components/parts/diag/DiagNavigation.vue';

export default {
  components: {
    Loading,
    DiagCorpHeader,
    DiagHeaderNavigation,
    TextArea,
    CheckBox,
    EgovProvisionsModal,
    ValidationErrorMessage,
    DiagNavigation,
  },
  mounted() {
    jQuery(function ($) {
      $(document).on('click', function() {
          $('.tooltip').fadeOut(200); // 画面のどこかがクリックされたときにツールチップを隠す
      });
    })
  },
  computed: {
    diagResultId() {
      return this.$store.getters['diag/getDiagResultId'];
    },
    diagResultItemId() {
      return this.$store.getters['diag/getDiagResultItemId'];
    },
    corpId() {
      return this.$store.getters['diag/getCorpId'];
    },
    diagTitle() {
      return this.$store.dispatch('diag/getTitle');
    },
    previousCheckItemLabel() {
      if (!this.previous.diagResultItemId) return '';
      return (this.previous.checkItem.length > 20)
        ? (this.previous.checkItem).slice(0, 20) + '...'
        : this.previous.checkItem;
    },
    nextCheckItemLabel() {
      if (!this.next.diagResultItemId) return '';
      return (this.next.checkItem.length > 20)
        ? (this.next.checkItem).slice(0, 20) + '...'
        : this.next.checkItem;
    },
    corpName() {
      return this.$store.getters['diag/getCorpName'];
    },
    corporateFeatureInfoLabels() {
      return this.$store.getters['diag/getCorporateFeatureInfoLabels'];
    },
    taskListSearchForm() {
      return this.$store.getters['diag/getTaskListSearchForm'];
    },
    manageCorpName() {
      return this.$store.getters['auth/getUser'].manageCorpNm;
    },
    isAdminUser() {
      return this.userAuthNo == 3;  // 専門家ユーザのみ
    },
  },
  // corpIdの監視　法人切替時に実行される
  watch: {
    async corpId() {
      if ( !this.isParamAccess ) {
        // Paramアクセスでない場合は、diagResultIdをクリアしてに遷移する
        // クリアしないとtopに遷移したときにdiagResultIdが引き継がれてしまう
        this.$store.dispatch('diag/setDiagResultId', null);
        this.$router.push({ name: 'diag-top' });
      }
    }
  },
  data() {
    return {
      isParamAccess: false,
      isProcessing: false,
      isShowEgovProvision: false,
      diagResultItem: {
        laborConsultantComment: '',
        remarks: '',
        diagItem: {
          task: '',
          remediation: '',
          guideCd: '',
          taskFixedFlg: false,
          provisionsDetail: null,
          riskLevel: {
            name: ''
          },
          diagSection: {
            sectionNm: ''
          }
        },
      },
      previous: {
        diagResultItemId: null,
        checkItem: '',
      },
      next: {
        diagResultItemId: null,
        checkItem: '',
      },
      score: 0,
      totalScore: 0,
      diagChartCategoryDetailLabelList: [],
      solutionList: [],
      isAdmin: false,
      isDiagAvailablePlan: false,
      isRemarksEditable: false,
      isAnswerChanged: false,
      sortOrder: null,
      isIpo: false,
      urlForms : [],
    }
  },
  validations: {
    diagResultItem: {
      remarks: { maxLength: maxLength(500) }
    }
  },
  destroyed () {
    window.removeEventListener("beforeunload", this.unLoadHandle);
  },
  created: async function() {

    this.isProcessing = true;

    // パラメータURLからのアクセスの場合は引き継いだ変数値を設定する
    if ( this.$route.params.corpId != undefined && this.$route.params.diagResultId != undefined && this.$route.params.diagResultItemId != undefined ){
      this.isParamAccess = true;
      this.$store.dispatch('diag/setCorpId', this.$route.params.corpId);
      this.$store.dispatch('diag/setDiagResultId', this.$route.params.diagResultId);
      this.$store.dispatch('diag/setDiagResultItemId', this.$route.params.diagResultItemId);

      // パラメータのチェック
      await this.checkParams(this.$route.params);

    }else{
      const authority = await this.$store.dispatch('auth/getAuthority')
      this.isAdmin = authority.isAdmin;
      this.userAuthNo = authority.userAuthNo;
      this.isDiagAvailablePlan = authority.isDiagAvailablePlan;
      this.getDiagResultItem(this.diagResultItemId);
      // パラメータURL空のアクセスフラグを解除する
      this.isParamAccess = false;
      this.isProcessing = false;
    }
    window.addEventListener("beforeunload", this.unLoadHandle, false); // reload,close対応
  },
  beforeRouteLeave (to, from, next) {
    if (this.isAnswerChanged && !to.query.usertype) {
      const answer = window.confirm("編集中のものは保存されませんが、よろしいですか？")
      next(answer)
    } else {
      next();
    }
  },
  methods: {
    changeForm(flag){
      this.urlForms.forEach((form) => {
        form.viewFlag = flag;
      });
    },
    toggle(id) {
      var tooltip = $('#'+id);
      tooltip.fadeIn(200);
    },
    toggleb(id) {
      var tooltip = $('#'+id);
      tooltip.fadeOut(200);
    },
    async checkParams(params) {
      let checkRes = await this.$axios.post('/ld/api/diag/checkParams', {
        corpId: params.corpId,
        diagResultId: params.diagResultId,
        diagResultItemId: params.diagResultItemId,
      });
      if (checkRes.status===500){
        let res = await this.$axios.post('/ld/api/corporate/getClientCorporateList', {});
        if (res) {
//          this.isParamAccess = false;
          this.isProcessing = false;
          this.$store.dispatch('diag/setCorpId', res.data.corporateList[0].corpId);
          this.$store.dispatch('diag/setDiagResultId', null);
          this.$store.dispatch('diag/setDiagResultItemId', null);
          this.$toast.error('以下の原因のためTop画面に戻ります。　　' + checkRes.data.message);
          this.$router.push({ name: 'diag-top' });
        }
      }else{
        await this.getDataForParamAccess(this.corpId, params.diagResultId);
        await this.getDiagResultTitle(params.diagResultId);

        const authority = await this.$store.dispatch('auth/getAuthority')
        this.isAdmin = authority.isAdmin;
        this.isDiagAvailablePlan = authority.isDiagAvailablePlan;
        await this.getDiagResultItem(params.diagResultItemId);
//        this.isParamAccess = false;
        this.isProcessing = false;
      }
    },
    async getDataForParamAccess(corpId, diagResultId = null) {
      if (corpId) {
        let res = await this.$axios.post('/ld/api/diag/getDataForParamAccess', {
          corpId: corpId,
          diagResultId: diagResultId,
        });
        if (res.status==200) {
          this.$store.dispatch('diag/setCorporateFeatureInfoLabels', res.data.corporateFeatureInfoLabels);
          this.$store.dispatch('diag/setCorpName', res.data.corpNm);
        }
      }
    },
    async getDiagResultTitle(diagResultId) {
      if (diagResultId) {
        let res = await this.$axios.post('/ld/api/diag/getDiagResultTitle', {
          diagResultId: diagResultId,
        });
        if (res.status==200) {
          this.$store.dispatch('diag/setTitle', res.data.diagTitle);
        }else{
          this.$toast.error(res.data.message);
        }
      }
    },
    async getDiagResultItem(diagResultItemId) {
        let res = await this.$axios.post('/ld/api/diag/getTaskDetail', {
        diagResultId: this.diagResultId,
        diagResultItemId: diagResultItemId,
        sortKey: this.taskListSearchForm.sortKey,
        diagSectionIds: this.taskListSearchForm.diagSectionIds,
        corpId: this.corpId,
      });
      if (res.status == 200) {
        this.diagResultItem = res.data.diagResultItem;
        this.sortOrder = res.data.sortOrder;
        this.diagChartCategoryDetailLabelList = res.data.diagChartCategoryDetailLabelList;
        this.isIpo = res.data.isIpo;
        this.score = res.data.diagResultScore.answeredCount;
        this.totalScore = res.data.diagResultScore.totalCount;
        this.solutionList = res.data.solutionList;
        this.previous = res.data.previousTask;
        this.next = res.data.nextTask;
        this.urlForms = res.data.urlForms;
        // 参考資料は1項目につき1つの欄として扱うため、データがなければ空の1件を用意する
        if (this.urlForms.length == 0) {
          this.urlForms.push({ content: "", viewFlag: false });
        }
      } else {
        this.$toast.error(res.data.message);
      }
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      this.isAnswerChanged = false;
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/diag/updateTaskDetail', {
        diagResultId: this.diagResultId,
        diagResultItem: this.diagResultItem,
        corpId: this.corpId,
        urlForms: this.urlForms,
      });
      if (res.status === 200) {
        this.$toast.info('保存しました。');
        this.score = res.data.diagResult.score;
        this.totalScore = res.data.diagResult.totalScore;
        this.isRemarksEditable = false;
        this.urlForms.forEach((form) => {
          form.viewFlag = false;
        });
      } else {
        this.$toast.error(res.data.message);
      }
      this.isProcessing = false;
    },
    async goTaskDetail(diagResultItemId) {
      if (this.isAnswerChanged) {
        const answer = window.confirm("編集中のものは保存されませんが、よろしいですか？");
        if ( answer ) {
          this.isRemarksEditable = false;
          this.isAnswerChanged = false;
          this.$router.replace({path: '/diag/task/'+this.corpId+'/'+this.diagResultId+'/'+diagResultItemId+'/task/detailparam'});
          this.$store.dispatch('diag/setDiagResultItemId', diagResultItemId);
          await this.getDiagResultItem(diagResultItemId);
          window.scrollTo({
            top: 0,
            behavior: "instant"
          });
        }
      } else {
        this.isRemarksEditable = false;
        this.isAnswerChanged = false;
        this.$router.replace({path: '/diag/task/'+this.corpId+'/'+this.diagResultId+'/'+diagResultItemId+'/task/detailparam'});
        this.$store.dispatch('diag/setDiagResultItemId', diagResultItemId);
        await this.getDiagResultItem(diagResultItemId);
        window.scrollTo({
          top: 0,
          behavior: "instant"
        });
      }
    },
    goTaskList() {
      this.$router.push({ name: 'task-list' });
    },
    showEgovProvision(value) {
      this.isShowEgovProvision = value;
    },
    async downloadGuideFile() {
      await saveAs('/ld/api/master/guide/downloadByGuideCd?guideCd=' + this.diagResultItem.diagItem.guideCd);
    },
    goSolutionDetail(solutionId) {
      this.$store.dispatch('solution/setSolutionId', solutionId);
      this.$router.push({ name: 'solution-detail' } );
    },
    emitSelectCorpList(params) {
      this.$store.dispatch('diag/setCorpId', params.corpId);
      this.$store.dispatch('diag/setCorpName', params.corpNm);
    },
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },
    changeRemarksEditable(value) {
      this.isRemarksEditable = value;
    },
    async unLoadHandle(evt) {
    if (this.isAnswerChanged) {
        evt.preventDefault()
        evt.returnValue = ''
      }
    },
  }
}

</script>

<style scoped>
.egovprovisionmodal-fade-enter-active {
  transition: all .2s ease;
}
.egovprovisionmodal-fade-leave-active {
  transition: all .2s ease;
}
.egovprovisionmodal-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}
.egovprovisionmodal-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateY(-50px);
  opacity: 0;
}

.gray-out {
  pointer-events: none;
}

.gray-out a {
  border: 1px solid #6a6a6a ;
  color: #a9a9a9;
}
</style>
